Vue.component("test", {   
    mixins: [SceneContentComponentMixin],

    data () {
        return {
            title: "lorem",
        }
    },
    template: `
        <div class="component test">
            <h1>test content-id: {{contentId}} {{title}}</h1>
        </div>
    `,    
});

touchKit.ComponentManager.register("test", {singleton: true});



